<template>
  <article>
    <chart-container
      class="mb-5"
      style="height: 100%"
      :loading="isLoading"
      :no-data="!orderStatistics.length"
    >
      <template #chart>
        <orders-bar-chart title="Заказы за сегодня" :items="orderStatistics" />
      </template>
    </chart-container>
    <proportion-charts-view ref="proportionChartsView" />
  </article>
</template>

<script>
  import OrdersTimeLoadChart from '@/components/stat/call-center/OrdersTimeLoadChart.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import ordersApi from '@/api/statistics/call-center/orders'
  import { mapState } from 'vuex'
  import ProportionChartsView from '@/components/stat/call-center/ProportionChartsView.vue'
  import ChartContainer from '@/components/stat/ChartContainer.vue'

  export default {
    name: 'CallCenterChartsView',
    components: {
      ChartContainer,
      ProportionChartsView,
      OrdersBarChart: OrdersTimeLoadChart,
    },
    mixins: [snackbarMessage],
    data () {
      return {
        isLoading: false,
        orderStatistics: [],
        proportionByOrdersStatuses: [],
        proportionByOrdersSVP: [],
        proportionByOrdersSources: [],
      }
    },
    computed: {
      ...mapState({
        ordersFilterDate: (state) => state.orders.ordersFilterDate,
      }),
    },
    watch: {
      ordersFilterDate () {
        this.fetchStatistics()
        this.fetchProportion()
      },
    },
    mounted () {
      this.$nextTick(() => {
        this.fetchStatistics()
        this.fetchProportion()
      })
    },
    methods: {
      fetchProportion () {
        this.$refs.proportionChartsView.fetchStatistics({
          from: this.ordersFilterDate,
          to: this.ordersFilterDate,
        })
      },
      async fetchStatistics () {
        this.isLoading = true

        try {
          const response = await ordersApi.fetchOrdersTimeLoadStatistics({
            from: this.ordersFilterDate,
            to: this.ordersFilterDate,
          })
          this.orderStatistics = response.items
        } catch (error) {
          this.showErrorFromResponse(error)
        } finally {
          this.isLoading = false
        }
      },
    },
  }
</script>

<style lang="less" scoped>
@import '@/assets/styles/statistic.less';
</style>
